const URL = 'http://localhost:3000/'
export default URL;
